import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import travelFormData from "./modules/travelformdata";
import generalLivingFormData from "./modules/generallivingformdata";
import directFormData from "./modules/directformdata";
import user from "./modules/user";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
});

export default new Vuex.Store({
    state: {
        server: "test",
        local_server: "http://localhost:5000/api",
        test_server: "https://tico2e.indiancarbon.org/api",
        production_server: "",
        authenticated: false,
        modalOpen: false,
        loginRedirect: "/"
    },
    getters: {
        authenticated(state) { return this.$auth.authenticated; },
        server(state) {
            switch (state.server) {
            case "local":
                return state.local_server;
            case "test":
                return state.test_server;
            case "production":
                return state.production_server;
            default:
                throw new Error("Invalid server id");
            }
        },
        modalOpen(state) { return state.modalOpen; },
        loginRedirect(state) { return state.loginRedirect; }
    },
    mutations: {
        eventData(state, data) {
            state.eventData = data;
        },
        modalOpen(state, isOpen) {
            state.modalOpen = isOpen;
        },
        loginRedirect(state, path) {
            state.loginRedirect = path;
        }
    },
    actions: {},
    modules: {
        travelFormData: travelFormData,
        directFormData: directFormData,
        generalLivingFormData: generalLivingFormData,
        user: user
    },
    plugins: [vuexLocal.plugin]
});



// WEBPACK FOOTER //
// ./src/store/index.js